import { useEffect, useState } from "react";
import Select from "react-select";

import { getTenant } from "../../../../utils/tenantManager";
import { getSubCategoriesByCategoryApi } from "../../../../services/website/subCategoryService";

type OptionType = {
  value: string;
  label: string;
  data?: any;
};

interface Props {
  value: OptionType | null;
  categoryId?: string;
  onChange: (value: OptionType | null) => void;
}

export default function SubCategoryAsyncSelect({
  value,
  categoryId,
  onChange,
}: Props) {
  useEffect(() => {
    console.log("Category:", categoryId);

    if (!categoryId) return;

    // call API here
  }, [categoryId]);

  const tenantId = getTenant();

  const [options, setOptions] = useState<OptionType[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const load = async () => {
      if (!categoryId) {
        setOptions([]);
        return;
      }

      try {
        setLoading(true);

        const res = await getSubCategoriesByCategoryApi(categoryId, tenantId!);

        setOptions(
          (res ?? []).map((x: any) => ({
            value: x.id,
            label: x.name,
            data: x,
          })),
        );
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [categoryId, tenantId]);

  return (
    <Select
      value={value}
      options={options}
      isLoading={loading}
      isDisabled={!categoryId}
      isClearable
      placeholder="Select Sub Category..."
      onChange={(option) => onChange(option as OptionType | null)}
    />
  );
}
